import { css } from '@emotion/core';
export var crossPromotion = {
  name: "y06ot1",
  styles: "max-width:1020px;margin-left:auto;margin-right:auto;"
};